import { AddressValue, COUNTRY_CODES, CountryCode } from '@/components/form/AddressInput';
import { Address } from '@/services/gql/graphql.generated';

export const isCountryCode = (value?: string): value is CountryCode => COUNTRY_CODES.includes(value as CountryCode);

export const mapAddress = (address?: Address): AddressValue => ({
  line1: address?.line1 ?? '',
  line2: address?.line2 ?? '',
  city: address?.city ?? '',
  postcode: address?.postcode ?? '',
  country: isCountryCode(address?.country) ? (address.country as CountryCode) : ''
});
